// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"_3puC9spNwIc9","container":"_2hjkppZj6bUd","text":"_24HW0nOv7UNx","money":"e_N7SrJVi9K6"};